import headerSerc from '@/components/decoration/data/headerSerc';
import swiperBg from '@/components/decoration/data/swiperBg';
import news from '@/components/decoration/data/news';
import menus from '@/components/decoration/data/menus';
import imageBanner from '@/components/decoration/data/imageBanner';
import imageBannerLR from '@/components/decoration/data/imageBannerLR';
import goodList from '@/components/decoration/data/goodList';
import goodWaterfall from '@/components/decoration/data/goodWaterfall'
import magicCube from '@/components/decoration/data/magicCube';
import guide from '@/components/decoration/data/guide';
import videoView from '@/components/decoration/data/videoView'
export default [
    headerSerc, // 搜索框
    swiperBg, // 轮播图
    news, // 新闻
    // videoView, // 视频
    menus, // 菜单
    imageBanner, // 广告图片
    imageBannerLR, // 广告图片左右
    goodList, // 商品列表-基础
    goodWaterfall, // 商品列表-瀑布
    magicCube, // 魔方格子
    guide, // 辅助线
]